import classnames from 'classnames';

import PopperTooltip from 'shared/ui/Popper/PopperTooltip';

import { Button } from '../Button';
import { buttonSize } from '../ButtonTypes';

import styles from './EditButton.module.scss';

type EditButtonType = {
  toggleEditMode: () => void;
  buttonText: string;
};

export const EditButton: React.FC<EditButtonType> = ({ toggleEditMode, buttonText }) => {
  const className = classnames(styles.position, styles.pencilEditButton, 'btn-box-tool pull-right');

  return (
    <PopperTooltip placement="bottom" overlay={buttonText}>
      <Button type="button" className={className} onClick={toggleEditMode} size={buttonSize.small}>
        <i className="lnr lnr-pencil" />
      </Button>
    </PopperTooltip>
  );
};
